<template>
    <div class="send-web-notification-config">
        <div class="config-field">
            <label>Bildirim Mesajı</label>
            <div class="input-with-variables">
                <a-textarea
                    v-model="localConfig.message"
                    :placeholder="'Bildirim mesajı ({{task.title}} gibi dinamik değişkenler kullanabilirsiniz)'"
                    :rows="3"
                    @change="emitChange"
                />
                <a-button type="link" size="small" @click="showVariablesPicker = true">
                    <i class="material-icons">code</i>
                    Değişkenler
                </a-button>
            </div>
            <small>
                Dinamik değişkenler: 
                <span v-pre>{{'{{task.title}}'}}</span>, 
                <span v-pre>{{'{{task.owner.name}}'}}</span>, vb.
            </small>
        </div>

        <div class="config-field">
            <label>Kullanıcı Tipi</label>
            <a-radio-group v-model="localConfig.userType" @change="emitChange" button-style="solid">
                <a-radio-button value="static">Sabit Kullanıcılar</a-radio-button>
                <a-radio-button value="dynamic">Dinamik</a-radio-button>
            </a-radio-group>
        </div>

        <div v-if="localConfig.userType === 'static'" class="config-field">
            <label>Kullanıcılar</label>
            <a-select
                v-model="localConfig.userStatic"
                mode="multiple"
                placeholder="Kullanıcılar seçin"
                style="width: 100%;"
                @change="emitChange"
            >
                <a-select-option
                    v-for="user in users"
                    :key="user._id"
                    :value="user._id"
                >
                    {{ user.name }}
                </a-select-option>
            </a-select>
        </div>

        <div v-if="localConfig.userType === 'dynamic'" class="config-field">
            <label>Dinamik Kullanıcılar</label>
            <a-select
                v-model="localConfig.userDynamic"
                mode="multiple"
                placeholder="Dinamik kullanıcı seçin"
                style="width: 100%;"
                @change="emitChange"
            >
                <a-select-option value="task_owner">Görev Sahibi</a-select-option>
                <a-select-option value="task_assignees">Görev Atananları</a-select-option>
                <a-select-option value="task_followers">Görev Takipçileri</a-select-option>
                <a-select-option value="task_collaborators">Görev İşbirlikçileri</a-select-option>
            </a-select>
        </div>

        <DynamicVariablesPicker
            v-if="showVariablesPicker"
            :visible="showVariablesPicker"
            @close="showVariablesPicker = false"
            @select="insertVariable"
        />
    </div>
</template>

<script>
import { mapState } from "vuex";
import DynamicVariablesPicker from "./DynamicVariablesPicker.vue";

export default {
    name: "SendWebNotificationConfig",
    components: {
        DynamicVariablesPicker
    },
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            localConfig: {
                message: '',
                userType: 'dynamic',
                userStatic: [],
                userDynamic: []
            },
            showVariablesPicker: false
        };
    },
    computed: {
        ...mapState({
            users: state => state.user.users.data
        })
    },
    watch: {
        value: {
            handler(newVal) {
                if (newVal) {
                    this.localConfig = JSON.parse(JSON.stringify(newVal));
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        emitChange() {
            this.$emit("input", JSON.parse(JSON.stringify(this.localConfig)));
        },

        insertVariable(variable) {
            this.localConfig.message += ` {{${variable}}}`;
            this.emitChange();
        }
    }
};
</script>

<style lang="scss" scoped>
.send-web-notification-config {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .config-field {
        label {
            display: block;
            font-weight: 600;
            margin-bottom: 8px;
            color: #1a1a1a;
        }

        small {
            display: block;
            color: #999;
            font-size: 12px;
            margin-top: 6px;
        }

        .input-with-variables {
            display: flex;
            gap: 8px;
            align-items: flex-start;

            .ant-textarea {
                flex: 1;
            }
        }
    }
}
</style>
